import { Icon, IconType } from "@sellar-io/components";
import { Tooltip } from "@sellar-io/components";
import { TooltipTrigger } from "@sellar-io/components";
import { TooltipContent } from "@sellar-io/components";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type InfoBadgeType = {
  title: string;
  body?: ReactNode;
  icon?: IconType;
  iconClassName?: string;
};

const InfoBadgeToolTipContent = ({
  infoContent,
}: {
  infoContent: InfoBadgeType;
}) => {
  return (
    <div
      className={
        "max-w-[300px] rounded-xl border border-zinc-300 bg-white px-4 py-3"
      }
    >
      {/* Tooltip tail */}
      <div className="absolute top-[-7px] left-1/2 -translate-x-1/2">
        <div className="h-3 w-3 rotate-45 transform border-t border-l border-gray-300 bg-white"></div>
      </div>

      <div className="flex items-center gap-2 bg-white">
        <Icon
          icon={infoContent.icon ?? "INFORMATION_OUTLINE"}
          className="flex-none text-zinc-800"
        />
        <div>
          <div className="text-sm font-semibold text-zinc-800">
            {infoContent.title}
          </div>
          {infoContent.body && (
            <div className="text-xs text-zinc-700">{infoContent.body}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export const InfoBadge = ({ infoContent }: { infoContent: InfoBadgeType }) => {
  return (
    <Tooltip placement="bottom">
      <TooltipTrigger className="flex w-fit items-center">
        <Icon
          className={twMerge(
            "pointer-events-auto cursor-pointer",
            infoContent.iconClassName,
          )}
          icon={infoContent.icon ?? "INFORMATION_OUTLINE"}
          size={0.8}
        />
      </TooltipTrigger>
      <TooltipContent>
        <InfoBadgeToolTipContent infoContent={infoContent} />
      </TooltipContent>
    </Tooltip>
  );
};
